import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import { useEleccion } from '../../contexts/eleccionContext';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import DatosCamara from './DatosCamara';

const Camaras = () => {
    const elecOptions = useEleccion();
    const nomenclator = useNomenclator()
    const territorios = elecOptions?.tabs.some(t => t.id ===  'territorios')
    const t = useTranslate();
    return(
        <div>
            {elecOptions?.camaras.map((camara)=>{
                return (<div className='camaracircunscripcion'>
                    <div className="headerSection">{`${t('circunscripcion')} ${nomenclator.nomAmbitos[elecOptions.idEleccion].cam[camara.cam].ca}`}</div>
                    <DatosCamara data={camara} tVisible={territorios} color={nomenclator.nomAmbitos[elecOptions.idEleccion].cam[camara.cam].co}/>
                </div>)
            })}
        </div>
    );
};

export default Camaras;
